import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  email: string | null;
  token: string | null;
  clientId: number | null;
  agency_name: string | null;
}

const initialState: UserState = {
  email: null,
  token: null,
  clientId: null,
  agency_name: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    setUserEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },

    setUserToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },

    setAgencyName(state, action: PayloadAction<string>) {
      state.agency_name = action.payload;
    },

    setClientId(state, action: PayloadAction<number>) {
      state.clientId = action.payload;
    },

    clearUser(state) {
      state.email = null;
      state.token = null;
      state.clientId = null;
      state.agency_name = null;
    },
  },
});

export const {
  setUserEmail,
  setUserToken,
  setAgencyName,
  setClientId,
  clearUser,
} = userSlice.actions;

export default userSlice.reducer;